// extracted by mini-css-extract-plugin
export default {"container":"ESeKT6","navigation":"BHEm7G","large":"vLiqej","small":"HvUnWd"};